import claimMessages from '@/modules/Claim/i18n/fr'
import damageMessages from '@/modules/Damage/i18n/fr'
import appointmentMessages from '@/modules/Appointment/i18n/fr'
import documentMessages from '@/modules/Document/i18n/fr'

export default {
  claim: { ...claimMessages },
  damage: { ...damageMessages },
  appointment: { ...appointmentMessages },
  document: { ...documentMessages },

  // actions
  actions: {
    addDamage: 'Ajouter',
    login: 'Login',
    select: 'Sélectionner',
    clear: 'Nettoyer',
    continue: 'Continuer',
    cancel: 'Annuler',
    import: 'Importer',
    export: 'Exporter',
    exportAll: 'Exporter tout',
    selectFile: 'Sélectionnez le fichier',
    search: 'Rechercher',
    save: 'Sauvegarder',
    delete: 'Éliminer',
    suppress: 'Suprimer',
    confirmAndContinue: 'Confirmer et continuer',
    confirmDommages: 'Valider les dommages', 
    goBack: 'Revenir en arrière',
    addMoreDamage: 'Ajouter des dommages',
    accept: 'Accepter'
  },

  // common damages
  commonDamages: {
    emptyData: 'Aucune donnée relative à ces dommages n’a été spécifiée'
  },

  // view: addDamages
  addDamages: {
    title: 'Dites-en nous plus sur vos dommages',
    buttonTitle: 'Ajouter des dommages',
    buttonTitleFeature: 'Suivant'
  },

  // view: multidamageList
  multidamageList: {
    delete: 'Suprimer',
    inputTitle: 'Veuillez nous indiquer la superficie de votre pièce',
    inputHint: 'En mètres carrés',
    btnContinue: 'Confirmer et continuer',
    btnAddDamage: 'Précisez ces dommages',
    btnAddDamagePhotoclaim: 'Faites une photo des dommages',
    btnAddDamageModal: 'Confirmer ces dommages',
    btnAddAllDamages: 'Suivant',
    calculateSurfaceLink: {
      text1: 'Vous ne connaissez pas la superficie?',
      text2: 'Nous vous aidons à la calculer',
      link: 'Calculer la superficie'
    },
    calculateSurfaceModal: {
      title: 'Calculer la superficie',
      input1: 'Combien de pas avez-vous compté sur la largeur de la pièce?',
      input2: 'Combien de pas avez-vous compté sur la longueur de la pièce?',
      inputErrorText: 'Il doit s’agir d’une valeur numérique supérieure à 1',
      text: 'Pour mesurer votre pièce, nous avons besoin de connaître la largeur et la longueur. Pour cela, nous vous demandons de vous positionner dans un coin et à partir de cet endroit, veuillez parcourir les deux côtés et noter le nombre de pas de la largeur et de la longueur de votre pièce.'
    }
  },

  // view: damageMobilier
  damageMobilier: {
    search: {
      predictibles: 'Choisir parmi nos catégories les plus fréquentes:',
      containerInputs: 'Rechercher parmi nos catégories',
      categoryList: 'Résultats de la recherche',
      containerEmptyTxt1: 'Votre recherche',
      containerEmptyTxt2: 'n’a pas obtenu',
      containerEmptyTxt3: 'de résultats'
    },
    category: {
      inputTextError: 'Champs obligatorie - valeur numérique',
      modal1: 'Avant de continuer',
      modal2: 'Vérifiez que ces données sont correctes:',
      date: 'Date d’achat',
      price: 'Prix d’achat',
      buttonsNextActionsTitle: 'Oui, c’est correct',
      buttonsNextActionsTitleWhiteBtn: 'Non, éditer'
    },
    damageResultUptec: {
      title: 'La valorisation de votre dommage se fera à partir de ce modèle :'
    }
  },

  // view: damageItems
  damagedItems: {
    buttonTitle: 'Suivant',
    defaultTitle: 'Quelles pièces ont été touchées?',
    defaultText: 'Indiquer dans quelles pièces les dommages se sont produits.'
  },

  // view: damagedPart
  damagedParts: {
    buttonTitle: 'Suivant',
    selectParts:
      'Indiquez les supports touchés ou si un nettoyage doit être réalisé'
  },

  // view: damageDetails
  damageDetails: {
    surfaceSmallText: 'En mètres carrés',
    titleFileInputEnsemble: 'Photos d’ensemble - Plus de 3 mètres',
    titleFileInputPres: 'Photos de près - Moins d’un mètre',
    errorPhoto:
      'Joignez la photo au format .png ou .jpg ou .jpeg. Pas plus de 6 Mo.'
  },

  // view: damagesConfirmed
  damagesConfirmed: {
    titleDamagesConfirmed: 'Résumé des dommages',
    photosEnsemble: 'Photos d’ensemble - Plus de 3 mètres',
    photosPres: 'Photos de près - Moins d’un mètre'
  },

  // component: furniture
  furniture: {
    title: 'Mobilier',
    empty: {
      short: 'Référence de sinistre manquante',
      long: 'Pour pouvoir ajouter des dommages au mobilier, entrez la référence du sinistre'
    },
    kindOfProperty: 'Type de propiété',
    kindOfPropertyOptions: {
      owner: 'Propriétaire',
      renter: 'Locataire'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    materialListBtn: 'Liste du matériel'
  },
  // notification
  notifications: {
    error: {
      0: {
        title: `Le code postal que vous avez introduit précédemment n'est pas accepté`,
        body: "Erreur durant l'action"
      },
      400: {
        title: 'Champ obligatoire non renseigné',
        body: 'Veuillez réviser les champs non renseignés'
      },
      404: {
        title: 'Error',
        body: 'Error'
      },
      500: {
        title: `Error`,
        body: "Une erreur s'est produite"
      },
      409: {
        title: "Erreur d'identification",
        body: 'Le sinistre existe déjà'
      },
      title: `Le code postal que vous avez introduit précédemment n'est pas accepté`,
      body: "Erreur durant l'action"
    },
    addDamage: {
      title: 'Dommage créé',
      body: "Le dommage s'est créé correctement"
    },
    newSinister: {
      title: 'Nouveau sinistre',
      body: "L'identifiant du sinistre a été modifié"
    },
    deleteDamage: {
      title: 'Dommage éliminé',
      body: 'Le dommage a été éliminé correctement'
    },
    pdfDamages: {
      title: 'Rapport créé',
      body: 'Rapport créé correctement'
    },
    pdfMaterial: {
      title: 'Rapport créé',
      body: 'Rapport créé correctement'
    },
    mailPdfMaterial: {
      title: 'Courriel envoyé',
      body: 'Courriel envoyé correctement',
      error: {
        title: 'Courriel non valide',
        body: 'Veuillez saisir un courriel correct'
      }
    },
    moCalculation: {
      title: 'Prix mis à jour',
      body: 'Rechargement du rapport en cours'
    },
    changeLanguage: {
      title: 'Changement de langue',
      body: 'Renvoi'
    },
    loadSinisterOK: {
      title: 'Sinistre chargé',
      body: 'Mise à jour des informations'
    },
    loadSinisterKO: {
      title: 'Erreur sinistre',
      body: 'Erreur lors du chargement de la perte'
    },
    paramChanged: {
      title: 'Paramètre modifié',
      body: 'La table se mettra à jour automatiquement.'
    },
    user: {
      isRequired: {
        title: 'Champs obligatoires manquants',
        body: 'Veuillez compléter correctement tous les champs'
      },
      isEmail: {
        title: 'Email erroné',
        body: 'L’email introduit n’est pas valable'
      },
      isSamePassword: {
        title: 'Veuillez repéter le mot de passe',
        body: 'Les mots de passe ne correspondent pas'
      },
      createdUser: {
        title: 'Utilisateur créé',
        body: 'Vue en cours d’actualisation'
      },
      modifiedUser: {
        title: 'Utilisateur modifié',
        body: 'Vue en cours d’actualisation'
      },
      deletedUser: {
        title: 'Utilisateur supprimé',
        body: 'Actualizando vistaVue en cours d’actualisation'
      },
      error: {
        400: {
          title: 'Champs obligatoires manquants',
          body: 'Veuillez vérifier les champs obligatoires'
        },
        500: {
          title: 'Erreur d’identification',
          body: 'L’utilisateur existe déja'
        },
        409: {
          title: 'Erreur',
          body: 'Une erreur ’est produite'
        }
      }
    },
    images: {
      uploadError: {
        title: 'Erreur de téléversement',
        text: 'Joignez la photo au format .png ou .jpg ou .jpeg. Pas plus de 6 Mo.'
      },
      inputImgError: {
        title: 'Erreur de téléversement',
        text: 'Une erreur s’est produite pendant le téléchargement de la photo. Vous pouvez continuer sans ajouter de photos.'
      }
    }
  },

  // datePicker
  datePicker: {
    literal: "Date d'achat"
  },

  // damagesTypes view
  damagesTypes: {
    titleNavbar: 'Quelle est la nature de vos dommages?'
  },

  // damageMobilierUptecFeature
  damageMobilierUptecFeature: {
    inputTxtValue: 'Indiquez la marque et le modèle'
  },

  // damageValidation
  damageValidation: {
    amount: '{amount} €',
    actions: {
      primary: 'Oui, j’accepte l’indemnisation proposée',
      secondary: 'Je souhaite parler avec un conseiller',
      tertiary: 'Non, je désire une autre solution'
    },
    materialsList: 'Télécharger le détail des coûts pour faire les travaux',
    upptecDossier: 'Rapport Mobilier'
  },

  // common
  common: {
    surface: 'Surface',
    line: 'Ligne',
    distance: 'Distance',
    actualCalc: 'Calcul en cours',
    selectOnTheMap: 'Sélectionnez sur la carte pour mesurer',
    mapAction: 'Mesurer la carte',
    mapActionLine: 'Mesurer la carte',
    min: 'Minimum',
    max: 'Maximum',
    total: 'Total',
    recommended: 'Recommandé',
    standard: 'Standard',
    noFile: 'Aucun fichier sélectionné',
    email: 'Courrier électronique',
    search: 'Recherche',
    results: 'Résultats',
    noresults: {
      short: 'Aucun résultat',
      long: "Il n'y a pas de résultats pour votre recherche"
    },
    true: 'Oui',
    false: 'Non',
    noOptions: 'Sans option',
    noSelected: 'Aucun sélectionné.',
    agentView: 'vue agent',
    managerView: 'vue gestionnaire',
    unit: '0 des unités | x {count} unité | x {count} des unités'
  },

  // view: error
  errorView: {
    title: 'Une erreur s’est produite',
    text: 'Notre équipe travaille pour résoudre le problème le plus rapidement possible.'
  },

  timedoutView: {
    title: 'Bonjour, le lien pour accéder à la prise de rendez-vous n’est plus disponible.',
    text: {
      upper: 'Nous vous invitons à contacter le service réparation au 01 40 09 38 22 pour prendre votre rendez-vous.',
      lower: 'Merci de votre compréhension.',
      lower2: 'Votre service client Société Générale Assurances.'
    }
  },

  // cart
  cart: {
    title: 'Liste des dommages introduits'
  },

  // component: form-container
  formContainer: {
    mursTitle: 'Nombre de murs touchés'
  },

  // component: customImage
  customImageInput: {
    default: {
      takeScreenshot: 'Encadrez les dégâts dans',
      repeat: 'Répéter',
      usePhoto: 'Utiliser des photos'
    },
    guideCamera: {
      takeScreenshot: 'Encadrez les dégâts dans le {guideIndexLiteral} guide',
      first: 'première',
      second: 'seconde',
      third: 'la troisième'
    },
    cornersCamera: {
      takeScreenshot: 'Desde el centro de la estancia, fotografía cada esquina',
      endPhotos: 'Finalizar'
    }
  },
  otpView: {
    title: 'Bonjour',
    text: {
      upper: `Bienvenue sur votre espace "Mes dommages" qui vous permet de décrire l'exhaustivité de vos dommages.`,
      upper2: `Pour y accéder, veuillez saisir le code qui vous a été envoyé sur votre téléphone au `,
      upper3: `Cette étape peut prendre jusqu'à 2 minutes.`,
      lower1: `Veuillez saisir votre code de vérification.`,
      lower2: `Un code a été envoyé sur votre téléphone au `,
      nocode: `Vous n'avez pas reçu votre code ?`,
      resend: 'Renvoyer un SMS',
      resendNotification: 'Message transféré',
      errorNotification: 'Code incorrect',
      popup: {
        text1: `Si vous n’avez pas reçu le code d’authentification, nous vous conseillons ces trois étapes : `,
        list1_1: `Vérifiez que le numéro de téléphone`,
        list1_2: `correspond au vôtre`,
        list2: `Si le numéro correspond, fermez cette fenêtre et cliquez sur “Renvoyez SMS”`,
        list3: `Si le numéro ne correspond pas, nous vous invitons à le renseigner sur votre `,
        link1: `Espace client`,
        text2: `Un conseiller Sogessur vous rappellera dans les 24h.`
      }
    }
  },

  // legal conditions
  cookiesAndLegal: {
    general: {
      title: 'Termes et conditions',
      paragraph1: `Avant de commencer, veuillez prendre connaissance de l'utilisation que nous faisons des cookies dans votre navigateur ainsi que les termes et conditions de service. En cliquant sur le bouton Accepter, vous confirmez avoir lu et pris connaissance des conditions relatives à ce service.`
    },
    cookies: {
      title: 'POLITIQUE DE COOKIES',
      paragraph1: {
        list1: `Par la suite, on vous montrera la politique de Cookies (dorénavant mentionnée en tant que “la politique de Cookies” ou “la politique”) régissant la Plateforme Web https://mavalue.plataforma-smart.com/  (dorénavant mentionnée en tant que “la Plateforme”, ou «MAValue»), titularité de Multiassistance, S.A. (ci-après dénommée “Multiassistance” ou “nous”).`,
        list2: `L’objectif de cette Politique de cookies est de vous aider à comprendre l’usage que l’on fait sur cette plateforme web des cookies, de leurs types, de leur finalité et de leur durée et de vous indiquer par ailleurs les options dont vous disposez pour configurer, pour administrer ou pour refuser ceux-ci.`,
        list3: `VEUILLEZ PRENDRE QUELQUES MINUTES POUR LIRE NOTRE POLITIQUE DE COOKIES, CELA NE VOUS PRENDRA PAS LONGTEMPS. NOUS VOULONS EXPLIQUER DE MANIÈRE SIMPLE, CLAIRE ET TRANSPARENTE COMMENT NOUS TRAITONS ET PROTÉGEONS VOS INFORMATIONS PERSONNELLES ET VOS DROITS. VOTRE SÉCURITÉ ET CELLE DE VOS DONNÉES PERSONNELLES EST FONDAMENTALE POUR NOUS ET NOUS PRENONS LEUR PROTECTION ADÉQUATE TRÈS AU SÉRIEUX.`,
        list4: `NOUS VOUS RECOMMANDONS ÉGALEMENT DE LIRE NOTRE POLITIQUE DE CONFIDENTIALITÉ.`
      },
      paragraph2: {
        title: `Que sont les cookies ?`,
        body: `Les cookies sont de petits fichiers ou de petits dispositifs téléchargés et stockés au sein de votre terminal (c’est-à-dire, le dispositif à partir duquel vous accédez à la Plateforme: l’ordinateur, le Téléphone portable, la Tablet ou tout autre dispositif connecté…) et qui permettent que la Plateforme ou le site web se rappelle de l’information liée à votre visite.
        Les cookies peuvent être de différents types en fonction de plusieurs paramètres:`,
        list1: `En fonction de l’entité gérant l’équipe ou le domaine d’où sont envoyés les cookies et où sont traités les données obtenues, nous pouvons distinguer ce qui suit:`,
        list2: `Les Cookies propres à nous : il s’agit de ceux que l’on envoie à l’équipement terminal de l’utilisateur à partir d’un équipement ou d’un domaine géré par Multiassistance et à partir desquels on fournit le service demandé par l’utilisateur.`,
        list3: `Les Cookies de tiers : il s’agit de ceux que l’on envoie à l’équipement terminal de l’usager à partir d’un équipement ou d’un domaine non géré par Multiassistance, mais par une autre entité traitant les données obtenues par les cookies. Lorsque les cookies sont installés à partir d’un équipement ou d’un domaine géré par Multiassistance, mais que, toutefois l’information recueillie par ceux-ci est gérée par un tiers, ils ne pourront pas être considérés comme étant des cookies propres à Multiassistance. Dans ce sens, Multiassistance pourra faire appel aux services d’entreprises d’analyses et de mesures afin de mesurer et/ou analyser le comportement de navigation des utilisateurs sur la plateforme, et, dans cette optique, qu’ils agissent en son nom et en sa représentation, du fait de l’analyse des données obtenues par l’usage des cookies de ces services, le tout dans le but d’améliorer le service fourni par Multiassistance.`,
        list4: `En fonction de la finalité pour laquelle sont traitées les données obtenues à travers les cookies, on peut distinguer entre:`,
        list5: `Des cookies techniques : Il s’agit de ceux permettant à l’utilisateur de naviguer à travers la plateforme et d’utiliser les différentes options ou les différents services y existant tel que, par exemple, le contrôle du trafic et la communication de données, l’identification de la session, l’accès aux données d’accès restreint, le rappel des éléments constituant une demande d’inscription ou de participation à un évènement, l’usage d’éléments de sécurité au cours de la navigation, la sauvegarde de contenus pour la diffusion de vidéos ou de son ou le partage de contenus dans les réseaux sociaux.`,
        list6: `Des cookies de personnalisation : Il s’agit de cookies permettant à l’utilisateur d’accéder au service avec certaines caractéristiques à caractère général prédéfinies en fonction d’un ensemble de critères sur le terminal de l’utilisateur tel que, par exemple, la langue, le type de navigateur utilisé pour accéder au service, la configuration régionale pour accéder au service, entre autres.`,
        list7: `Des cookies d’analyses : Il s’agit de ceux permettant à leur responsable le suivi et l’analyse du comportement des utilisateurs des sites web auxquels ils sont attachés. L’information recueillie moyennant ce type de cookies est utilisée afin de mesurer l’activité sur la plateforme et pour l’élaboration de profils de navigation des utilisateurs sur les sites en question, sur les applications et sur les plateformes en vue de la mise en place d’améliorations: en fonction de l’analyse des données consultées par les utilisateurs du service.`,
        list8: `Des cookies publicitaires : Il s’agit de ceux permettant la gestion de la manière la plus efficace possible, des espaces publicitaires ayant été, le cas échéant, inclus par l’éditeur sur une page web, une application ou une plateforme à partir de laquelle sera fourni le service demandé sur la base de critères tels que le contenu édité ou la fréquence d’affichage des publicités.`,
        list9: `Des cookies de publicité comportementale : Il s’agit de ceux permettant la gestion, de la manière la plus efficace possible, des espaces publicitaires que l’éditeur, le cas échéant, aurait inclus au sein d’un site web, d’une application ou d’une plateforme à partir de laquelle sera fourni le service demandé. Ces cookies sauvegardent l’information du comportement des utilisateurs ayant été obtenue par le biais de l’observation continue de ses habitudes de navigation, ce qui permet de développer un profil spécifique en fonction de celui-ci.`,
        list9_1: `En fonction du délai de temps où ils sont actifs au sein de l’équipement terminal (la temporalité), on pourra distinguer ce qui suit:`,
        list10: `Des cookies de session : Il s’agit de cookies conçus pour recueillir et pour sauvegarder les données au cours de l’accès de l’utilisateur à la plateforme.`,
        list11: `Des cookies persistants : Il s’agit de cookies où les données continuent à être sauvegardées au sein du terminal et qui peuvent être traitées au cours d’une période de temps définie par le responsable du cookie, et pouvant varier de quelques minutes à plusieurs années.`,
        footer: `Vous pouvez consulter les informations sur les cookies et autres traceurs fournies par la Commission National de l’Informatique et Libertés (CNIL) en cliquant ici.`
      },
      paragraph3: {
        title: `Quels sont les cookies utilisés sur la plateforme ?`,
        body: `Cette plateforme utilise des cookies techniques nécessaires pour permettre et optimiser la navigation de l'utilisateur et les fonctionnalités de la plateforme.
        Les cookies utilisés sont nécessaires pour permettre la navigation sur la Plateforme et veiller à son bon fonctionnement, donc ils ne peuvent pas être refusés par l’usager et la désactivation ou l’annulation de ceux-ci entraînera l’impossibilité d’utiliser la Plateforme.
        A continuation, sont identifiés les cookies utilisés au sein de cette Plateforme: `,
        list1: `Cookie`,
        list1_1: `mavalue.plataforma-smart`,
        list2: `Finalité`,
        list2_1: `Cookie pour vous permettre de rester connecté`,
        list3: `Gestion`,
        list3_1: `Propre`,
        list4: `Durée`,
        list4_1: `1 an `
      },
      paragraph4: {
        title: `Les mises à jour et les changements concernant la politique de cookies.`,
        body: `Cette Politique de Cookies pourra être modifiée en fonction des exigences législatives, réglementaires ou ayant la finalité d’adapter cette politique aux instructions stipulées par la Commission Nationale de l’Informatique et Libertés (CNIL), dans cette optique on conseille aux utilisateurs de la consulter périodiquement.`
      }
    },
    legal: {
      title: 'MENTIONS LÉGALES',
      paragraph1: {
        list1: `L’accès aux solutions numériques et à l’ensemble des fonctionnalités contenues au sein de cette Plateforme est inclus dans les services contractés par la société qui détient le droit de les utiliser (la compagnie), au nom de laquelle vous acquérez la condition d'utilisateur de celles-ci. L’accès, la navigation et l’usage de la Plateforme implique le fait de satisfaire la condition d’utilisateur de celle-ci (dorénavant mentionné en tant que “l’utilisateur”) et, par conséquent, de se souscrire à l’acceptation expresse et sans réserves par l’utilisateur de l’ensemble des termes et des conditions contenus au sein des présentes Mentions légales, raison pour laquelle nous recommandons sa lecture attentive, de telle sorte qu’en cas de désaccord,  il suffirait de ne pas l’accepter par le moyen prévu à cet effet, un fait rendant impossible l’usage de la Plateforme, des services et des fonctionnalités établis à travers cette dernière.`
      },
      paragraph2: {
        title: `RENSEIGNEMENTS GÉNÉRAUX.`,
        subParagraph1: {
          title: `EDITEUR`,
          line1: `MULTIASSISTANCE, S.A. (Ci-après dénommée, «Multiassistance» ou bien, «nous»); `,
          line2: `Société anonyme au capital de 48.494,10 euros`,
          line3: `146 boulevard de Charonne`,
          line4: `75020 Paris`,
          line5: `N° Identification TVA intracommunautaire : FR 62413114901`,
          line6: `Nom du Directeur de la publication : M. Íñigo Astarloa Echevarrieta`,
          line7: `Tel : 01 40 09 36 60`,
          line8: `Email : info@multiasistencia.com; contact.clients@Multiassistance.com `
        },
        subParagraph2: {
          title: `HEBERGEUR`,
          line1: `Amazon Web Services EMEA SARL`,
          line2: `38 avenue John F Kennedy, L-1855 Luxembourg`,
          line3: `Fax: 352 2789 0057`
        }
      },
      paragraph3: {
        title: `PLATEFORME WEB : USAGE, FINALITÉ ET RÉGIME JURIDIQUE APPLICABLE.`,
        list1: `Multiassistance est une entreprise spécialisée dans la gestion et la réparation des sinistres en assurance habitation et commerciale pour les compagnies d'assurance et, dans le cadre de cette activité, elle fournit à ses clients des solutions numériques visant à optimiser et à digitaliser leurs processus opérationnels.`,
        list2: `Le Plataforme est le canal par lequel les utilisateurs autorisés peuvent utiliser les différentes solutions qu'ils ont contractées ou que la compagnie à laquelle ils appartiennent ou avec laquelle ils entretiennent une relation de collaboration a contractée. `,
        list3: `L’accès aux solutions numériques et à l’ensemble des fonctionnalités contenues au sein de cette Plateforme est inclus dans les services contractés par la société qui détient le droit de les utiliser (la compagnie), au nom de laquelle vous acquérez la condition d'utilisateur de celles-ci. L’accès et utilisation de la Plateforme implique l’acceptation de toutes les conditions présentes, ainsi que de toute autre condition pouvant être établie, modifiée et/ou élargie sur base de certaines nécessités présentes ou futures du Service. Multiassistance sera habilitée pour modifier à tout moment le contenu de ces conditions ainsi que des services et des fonctionnalités établis dans la Plateforme tout en comprenant que la publication de ces changements en question et des modifications par le présent moyen de communication sera suffisant, sans pour autant que cela ne porte préjudice à la possibilité de l’utilisateur d’accepter ou de ne pas accepter les modifications en question. En cas de non-acceptation, cela pourrait entraîner l’impossibilité d’utiliser la Plateforme pour toutes ou certaines fonctionnalités stipulées par cette dernière.`
      },
      paragraph4: {
        title: `CONDITIONS D’ACCÈS ET D’USAGE.`,
        body1: `L’utilisateur s’engage à faire un usage approprié et licite de la Plateforme, ainsi que des contenus, des produits et des services établis à partir de celle-ci, conformément à la législation applicable à tout moment, aux conditions présentes, au sens moral et aux bonnes habitudes généralement acceptées ainsi qu’à l’ordre public.  `,
        body2: `Par ailleurs, l’utilisateur de la Plateforme s’engage à ce qui suit:`,
        list1: `Garantir l’authenticité, la véracité, la mise à jour et l’exactitude de toutes les données communiquées par le biais de la Plateforme, en précisant qu’en cas contraire, l’utilisateur en sera l’unique responsable.`,
        list2: `Utiliser la Plateforme exclusivement pour les fins et les fonctionnalités convenues par Multiassistance, il est ainsi interdit à l’utilisateur de faire usage de la Plateforme pour tout autre fin ou tout autre moyen.`,
        list3: `Faire un usage légal et légitime de la Plateforme, en évitant tout usage non autorisé, frauduleux, illégal ou illégitime de celle-ci et/ou des contenus et de l’information établis par cette dernière, en évitant d’aller à l’encontre des présentes Mentions Légales ainsi que du règlement applicable, de porter atteinte aux droits et aux intérêts légitimes de Multiassistance ou de tout autre tiers pouvant être affecté par cette action.`,
        list4: `Ne pas entraîner de dommages aux systèmes physiques ou logiques de la Plateforme, de ses fournisseurs ou de tiers; ne pas tenter d’enfreindre les mesures de sécurité ou d’authentification de celle-ci, ne pas mener d’actions provoquant une saturation disproportionnée ou non nécessaire de l’infrastructure ou de l’environnement de communications ayant attrait à la Plateforme et au Service, en attaquant d’une manière ou d’une autre ce dernier. Multiassistance pourra mettre en place toute mesure préventive ou correctrice estimée comme nécessaire afin de protéger ses intérêts conformément au fonctionnement correct de la Plateforme, du Service et des fonctionnalités spécifiées.`,
        list5: `Ne pas introduire ou ne pas diffuser sur le réseau des virus informatiques ou tout autre système physique ou logique pouvant provoquer des dommages tels que des virus, un code malicieux ou tout autre programme ou archives nuisibles.`,
        list6: `Ne pas tenter d'accéder, d'utiliser et / ou manipuler des données ou toute autre information qui est traitée par la Plateforme.`,
        list7: `En particulier, et à titre uniquement indicatif et non exhaustif, l’utilisateur s’engage à ne pas transmettre, diffuser ou mettre à disposition de tiers des renseignements, des données, des contenus ou des messages pouvant porter atteinte aux droits de Multiassistance ou de tiers.`,
        list8: `Ne pas accéder sans autorisation ou utiliser une fausse identité, supplanter l'identité de tiers ou utiliser un profil ou effectuer toute autre action qui pourrait générer de la confusion ou induire en erreur sur l'identité correcte de l'utilisateur en question.`
      },
      paragraph5: {
        title: `LA PROPRIÉTÉ INDUSTRIELLE ET INTELLECTUELLE.`,
        list1: `L’utilisateur reconnaît et accepte que tous les droits de propriété intellectuelle et industrielle sur la Plateforme et tous ses éléments associés correspondent à Multiassistance ou aux tiers ayant autorisés spécifiquement Multiassistance pour cette finalité.`,
        list2: `En aucun cas l’accès ou la navigation sur la Plateforme implique aucun type de désistement, de transmission, de licence ou de cession totale ni partielle de ces droits en question, à moins que le cas contraire soit stipulé expressément et par écrit.`,
        list3: `Tous les droits de propriété intellectuelle et industrielle concernant les contenus et/ou les services de la Plateforme sont réservés et, en particulier, il est interdit de modifier, de copier, de reproduire, de communiquer publiquement, de transformer ou de distribuer, par tout moyen ou sous tout format, la totalité ou une partie des contenus y étant inclus à des fins publiques ou commerciales, à moins que l’on ne dispose de l’autorisation préalable, expresse et par écrit des titulaires respectifs.`,
        list4: `L’utilisateur allant à l’encontre de ces limitations et de ces interdictions reconnaît qu’il en assume la responsabilité exclusive, en déchargeant ainsi Multiassistance, ou tout autres tiers pouvant être affecté par l’action de l’utilisateur de toute responsabilité.`
      },
      paragraph6: {
        title: `EXCLUSION DE GARANTIES ET DE RESPONSABILITÉ.`,
        list1: `Multiassistance adoptera plusieurs mesures pour protéger la Plateforme et les contenus contre les attaques informatiques de tiers. Dans tous les cas, il est important que les utilisateurs soient responsables afin de prendre toutes les mesures techniques appropriées pour contrôler raisonnablement les menaces auxquels ils sont exposés, y compris la mise à jour des systèmes de détection des logiciels malveillants, tels que les virus, chevaux de Troie, etc. ainsi que des correctifs de sécurité pour les navigateurs concernés.`,
        list2: `L'utilisateur est responsable de conserver ses codes d'accès et doit éviter leur utilisation par des tiers non autorisés et d'adopter les mesures de sécurité nécessaires pour maintenir la confidentialité des systèmes d'accès et de vérification ou des codes établis en relation avec la Plateforme. Multiassistance décline toute responsabilité en cas de négligence, d'imprudence ou de mauvaise utilisation par l'utilisateur ou un tiers non autorisé et ne serait en aucun cas responsable des dommages et des préjudices pouvant découler de cet accès non autorisé.`,
        list3: `Multiassistance se réserve le droit de suspendre sans avis préalable l’accès aux utilisateurs qui, conformément à son critère, ne respectent pas les règles d’usage de la Plateforme et, par ailleurs, d’exercer les mesures légales pertinentes, sans que cela ne génère aucun droit d’indemnisation au bénéfice de l’utilisateur ayant pu en être affecté.`,
        list4: `Multiassistance déclinent toute responsabilité découlant des dommages et des préjudices de tout type pouvant émaner de l’usage des services et des contenus par les utilisateurs, ou pouvant découler du manque d’information, d’exactitude ou de véracité que ceux-ci fourniraient dans le cadre de la Plateforme et du Service. En aucun cas Multiassistance ne pourra être tenu responsable de l'utilisation que les utilisateurs et/ou des tiers font de la Plateforme, ainsi que des dommages et des préjudices pouvant en découler.`
      },
      paragraph7: {
        title: `LA MODIFICATION DES MENTIONS LÉGALES.`,
        list1: `Multiassistance se réserve le droit de modifier les informations contenues dans les présentes mentions légales, afin de les adapter à de futures nouveautés législatives, doctrinales ou jurisprudentielles découlant de l’application, soit pour des motifs techniques, opérationnels, commerciaux, corporatifs et entrepreneuriaux, en informant préalablement et raisonnablement les utilisateurs des changements ayant lieu dès que possible. Dans tous les cas, il est recommandé, lors de chaque accès à la Plateforme, de lire attentivement les mentions légales.`,
        list2: `En cas de doute relatif aux présentes mentions légales, l’utilisateur pourra contacter Multiassistance par courriel à l’adresse électronique suivante: info@multiasistencia.com`
      }
    }
  },
  textDescriptionError:
    'Veuillez compléter la description des dommages avant de continuer'
}
